<div class="video-container">
  <iframe
    width="560"
    height="315"
    [src]="videoUrl"
    frameborder="0"
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
  ></iframe>
</div>
